// extracted by mini-css-extract-plugin
export default {"title":"Title_title__7izDv","name-title":"Title_name-title__WoK7P"};